
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { getAdminMenuItems, getCourierMenuItems } from './sidebarUtils';
import { useAuth } from '@/contexts/AuthContext';

export function SidebarNavigation() {
  const location = useLocation();
  const { user, isAdmin } = useAuth();
  
  // Выбираем соответствующие пункты меню в зависимости от роли пользователя
  const menuItems = isAdmin ? getAdminMenuItems() : getCourierMenuItems();
  
  return (
    <div className="flex flex-col px-2">
      <div className="text-white mb-6 px-4 uppercase tracking-wider">
        Навигация
      </div>
      
      <nav className="space-y-2 px-2">
        {menuItems.map((item) => (
          <Button
            key={item.path}
            asChild
            variant="ghost"
            size="sm"
            className={cn(
              "w-full justify-start text-base",
              location.pathname === item.path 
                ? "bg-tuktuk-teal/10 text-white font-medium" 
                : "hover:bg-tuktuk-teal/10 hover:text-white text-white"
            )}
          >
            <Link to={item.path}>
              <item.icon className="mr-3 h-5 w-5" />
              {item.title}
            </Link>
          </Button>
        ))}
      </nav>
    </div>
  );
}
